var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2C5.55964 2 5 2.55964 5 3.25C5 3.94036 5.55964 4.5 6.25 4.5H7.5V7.5H2.25C1.55964 7.5 1 6.94036 1 6.25V5.75C1 5.05964 1.55964 4.5 2.25 4.5H4.37889C4.13957 4.14248 4 3.71254 4 3.25C4 2.00736 5.00736 1 6.25 1C6.95682 1 7.58751 1.32592 8 1.83567C8.41249 1.32592 9.04318 1 9.75 1C10.9926 1 12 2.00736 12 3.25C12 3.71254 11.8604 4.14248 11.6211 4.5H14.25C14.9404 4.5 15.5 5.05964 15.5 5.75V6.25C15.5 6.94036 14.9404 7.5 14.25 7.5H8.5V4.5H9.75C10.4404 4.5 11 3.94036 11 3.25C11 2.55964 10.4404 2 9.75 2C9.05964 2 8.5 2.55964 8.5 3.25V4.5H7.5V3.25C7.5 2.55964 6.94036 2 6.25 2Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.5H2V13C2 13.8284 2.67157 14.5 3.5 14.5H7.5V8.5Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5V14.5H13C13.8284 14.5 14.5 13.8284 14.5 13V8.5H8.5Z",
    fill: "#BFBFBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift);
export default __webpack_public_path__ + "static/media/ic_gift.c857bd59200a4790868ea69d6f00e67a.svg";
export { ForwardRef as ReactComponent };